import type { PaginationState } from "../../types";

// Query keys for the home-page carousel (sliders)
export const carouselKeys = {
  all: ["carousels"] as const,
  list: (params: PaginationState) =>
    [...carouselKeys.all, "list", params] as const,
};
